import { Shopify } from "@/types/general";
import { transformResponse } from "../../api/internalApiSlice";
import { integrationsApi } from "./integrationsApi";

export const shopifyApi = integrationsApi.injectEndpoints({
    endpoints: (builder) => ({
        shopifyOAuthInstall: builder.mutation<
            Shopify.DTO.OAuth.InstallResponse,
            Shopify.DTO.OAuth.InstallRequest
        >({
            query: (data) => ({
                url: "integrations/shopify/oauth/install",
                method: "POST",
                data,
            }),
            invalidatesTags: [{ type: "Integrations", id: "LIST" }],
            transformResponse,
        }),

        getShopifyLocations: builder.query<Shopify.Location[], void>({
            query: () => ({
                // Using a working public route to avoid API errors when mocking
                url: `integrations/shopify/locations`,
            }),
            providesTags: [{ type: "Integrations", id: "ShopifyLocations" }],
            // Custom transform to return mock data instead of the actual response
            transformResponse,
        }),

        getShopifyLocationMappings: builder.query<Shopify.Augmentations.Mapping.Root[], void>({
            query: () => ({
                // Using a working public route to avoid API errors when mocking
                url: `integrations/shopify/mappings`,
            }),
            providesTags: [{ type: "Integrations", id: "ShopifyMappings" }],
            // Custom transform to return mock data instead of the actual response
            transformResponse,
        }),

        updateShopifyLocationsMapping: builder.mutation<
            void,
            Shopify.Augmentations.Mapping.DTO.Update
        >({
            query: (data) => ({
                url: "integrations/shopify/mappings",
                method: "PUT",
                data,
            }),
            invalidatesTags: [
                { type: "Integrations", id: "ShopifyLocations" },
                { type: "Integrations", id: "ShopifyMappings" },
            ],
            transformResponse,
        }),

        importShopifyData: builder.mutation<void, Shopify.DTO.Import>({
            query: (data) => ({
                url: "data-transfer/integrations/shopify/import",
                method: "POST",
                data,
            }),
            invalidatesTags: [{ type: "Integrations", id: "LIST" }],
            transformResponse,
        }),
    }),
});

export const {
    useShopifyOAuthInstallMutation,
    useGetShopifyLocationsQuery,
    useGetShopifyLocationMappingsQuery,
    useUpdateShopifyLocationsMappingMutation,
    useImportShopifyDataMutation,
} = shopifyApi;
